<template>
  <div class="card modal-card">
    <div class="modal-card-body is-paddingless">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content pd-40px">
        <div class="level">
          <div class="level-left">
            <div class="columns">
              <div class="column">
                <h1 class="title is-size-4">
                  {{ $t('detailDevis.commandePartiel.title') }}
                </h1>
              </div>
            </div>
          </div>
          <div class="level-right">
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.cancel')}}
                </a>
              </div>
              <div class="is-pulled-left boutonAction">
                <a class="button is-addOrEdit" @click="commanderPartiellement"
                   :class="{'button-access-no-permission pointer-no-drop'
                   : getLignesSelectionnees.length === 0}">
                  {{ $t('detailDevis.commandePartiel.actions.commander')}}
                </a>
              </div>
            </b-field>
          </div>
        </div>
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('detailDevis.commandePartiel.generation.title')">
              <b-select v-model="generationCommande" expanded>
                <option v-for="typeGeneration in constantes.LISTE_TYPE_GENERATION"
                        :key="typeGeneration.code"
                        :value="typeGeneration.code">
                  {{ $t(typeGeneration.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12 level columns">
            <div class="level-left column is-6 pdr-0">
              <div class="columns">
                <b-field :label="$t('detailDevis.commandePartiel.filtre.periode')"
                         class="column is-5">
                  <date-picker :dates="filtres.periode" :display-arrow="false">
                  </date-picker>
                </b-field>
                <b-field :label="$t('detailDevis.commandePartiel.filtre.typeProduit')"
                         class="column is-7">
                  <b-select v-model="filtres.typeProduit" expanded>
                    <option></option>
                    <option v-for="typeProduit in listeTypeProduit"
                            :key="typeProduit.code"
                            :value="typeProduit.code">
                      {{ $t(typeProduit.libelle) }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
            <div class="level-right column is-3 has-text-right">
              {{ $t('detailDevis.commandePartiel.select') }}
              <span class="has-text-weight-bold"> {{ getMontantSelect | formatDevise }} </span>
            </div>
          </div>
        </div>
        <v-client-table :data="getLignesFiltered"
                        class='mgt-10px column is-12 is-paddingless'
                        :columns="columns"
                        :options="options"
                        ref='tableLignes'>
          <div slot="selected" slot-scope="props" class="has-text-centered">
            <b-checkbox :value="props.row.selected" @input="updateSelected(props.row)">
            </b-checkbox>
          </div>
          <div slot="totalHtAvecLigneRemise" slot-scope="props" class="has-text-right">
            {{ getTotalHtAvecLigneRemise(props.row) | formatDevise }}
          </div>
          <div slot="libelle" slot-scope="props">
            <detail-ligne :ligne="props.row"></detail-ligne>
          </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { generationCommandes } from '@/api/commande/index';
import moment from 'moment';
import {
  PERSONNALISE,
  LISTE_TYPE_GENERATION,
  TYPE_GENERATION_AUCUN,
  REGROUPEMENT,
} from '@/configuration/devisConf';
import {
  TEXTS, NO_PAGINATION, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import datePicker from '@/components/general/datePicker';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';
import { DATE_MAX, DATE_MIN } from '@/configuration/general/dateConf';
import detailLigne from '@/components/bodac/devis/detailDevis/popUpCommanderPartiellement/detailLigne';
import { SET_COMMANDE } from '@/store/modules/commande-mutation-type';
import validationPassageCommande from '@/services/devisCommandes/validation/validationPassageCommande';
import messageErreur from '@/services/general/messageErreur';
import addReferenceEcheancierToAllLignes
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToAllLignes';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';

const Commandes = createNamespacedHelpers('commande');

export default {
  props: {
    lignesCommande: {
      type: Array,
      required: true,
    },
    filtres: {
      type: Object,
      required: false,
    },
    devisId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lignes: [],
      listeTypeProduit: [],
      constantes: {
        LISTE_TYPE_GENERATION,
      },
      generationCommande: TYPE_GENERATION_AUCUN,
      messages: [],
      error: false,
    };
  },
  components: {
    datePicker,
    detailLigne,
    errorMsgComponent,
  },
  computed: {
    areAllSelected() {
      return this.getLignesFiltered.length
        && !this.getLignesFiltered.some(ligne => !ligne.selected);
    },
    iconSelectTotal() {
      if (this.areAllSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      return ['selected', 'libelle', 'totalHtAvecLigneRemise'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$i18n.t('detailDevis.commandePartiel.tab.produit'),
          totalHtAvecLigneRemise: this.$i18n.t('detailDevis.commandePartiel.tab.montant'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.areAllSelected;
                    this.getLignesFiltered.forEach(ligne => {
                      ligne.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: [],
        columnsClasses: {
          selected: 'colonneSelected',
          totalHtAvecLigneRemise: 'width-100',
        },
      };
    },
    getLignesSelectionnees() {
      return this.getLignesFiltered.filter((ligne) => {
        return ligne.selected;
      });
    },
    getLignesFiltered() {
      return this.lignes.filter((ligne) => {
        let dateDebut = ligne.dateDebut;
        if (ligne.ligneReseau && ligne.ligneReseau.anneeSemaine) {
          dateDebut = getDateWithAnneeSemaineAndJourDepart(
            ligne.ligneReseau.anneeSemaine,
            ligne.ligneReseau.jourDepart,
          );
        }
        const periodeDateDebut = this.filtres.periode.dateDebut
          ? moment(this.filtres.periode.dateDebut) : moment(DATE_MIN);
        const periodeDateFin = this.filtres.periode.dateFin
          ? moment(this.filtres.periode.dateFin) : moment(DATE_MAX);
        return !!((!this.filtres.typeProduit
          || (this.filtres.typeProduit && ligne.typeProduit === this.filtres.typeProduit))
        && (!dateDebut || moment(dateDebut).isBetween(periodeDateDebut, periodeDateFin, 'day', '[]')));
      });
    },
    getMontantSelect() {
      const lignes = this.getLignesSelectionnees;
      if (lignes.length === 0) return 0;
      let total = 0;
      lignes.forEach((ligne) => {
        total += this.getTotalHtAvecLigneRemise(ligne);
      });
      return total;
    },
  },
  methods: {
    ...Commandes.mapMutations({
      setCommande: SET_COMMANDE,
    }),
    getTotalHtAvecLigneRemise(ligne) {
      if (ligne.type !== REGROUPEMENT || ligne.lignesCommande.length === 0) {
        return ligne.totalHtAvecLigneRemise;
      }
      return ligne.lignesCommande.map(ligne => ligne.totalHtAvecLigneRemise)
        .reduce((montantTotal, montant) => montantTotal + montant);
    },
    updateSelected(ligneToChange) {
      const ligneFind = this.lignes.find((ligne) => {
        return ligne.id === ligneToChange.id;
      });
      if (ligneFind) this.$set(ligneFind, 'selected', !ligneToChange.selected);
    },
    async commanderPartiellement() {
      if (this.getLignesSelectionnees.length === 0) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          id: this.devisId,
          lignesCommandeIds: this.getLignesSelectionnees.map(ligne => ligne.id),
          typeGeneration: this.generationCommande,
        };
        const commandes = (await generationCommandes(params)).data.result;
        if (commandes.length > 1) {
          loadingComponent.close();
          messageSucces(this.$i18n.t('detailDevis.messages.succes'));
          await this.$router.push({ name: 'l.bodac.commandes-listeReferencesId', params: { referenceId: this.devisId } });
          return;
        }
        commandes[0].lignesCommande.forEach((lignes) => {
          lignes.affectation = [];
          lignes.selected = false;
        });
        addReferenceEcheancierToAllLignes(commandes[0]);
        initializeCommandeDevis(commandes[0]);
        this.setCommande(commandes[0]);
        await this.$router.push({ name: 'm.bodac.commandes-ajout' });
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          this.messages = [];
          validationPassageCommande(e.response, this.messages, this.$i18n);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    const lignes = cloneDeep(this.lignesCommande);
    lignes.forEach((ligne) => {
      ligne.selected = false;
      if (ligne.typeProduit && !this.listeTypeProduit.find((liste) => {
        return liste.code === ligne.typeProduit;
      })) {
        const categorieProduit = CATEGORIE_PRODUIT.find((categorie) => {
          return categorie.code === ligne.typeProduit;
        });
        if (categorieProduit) this.listeTypeProduit.push(categorieProduit);
      } else if (ligne.referencePersonnalise) {
        if (!this.listeTypeProduit.find((liste) => {
          return liste.code === PERSONNALISE;
        })) {
          this.listeTypeProduit.push({
            code: PERSONNALISE,
            libelle: 'detailDevis.commandePartiel.generation.typeProduit.reseauPerso',
          });
        }
        ligne.typeProduit = PERSONNALISE;
      }
    });
    this.lignes = lignes;
  },
};

</script>
